import React, { Component } from 'react';

import { Form } from 'react-form';
import { addClassToBody }  from '../../utils/utils';
import TextFields from '../UI/TextFiled';

class ForgotPassword extends Component {

    render() {
        addClassToBody();
        return (
            <div className="sign-form sign-forgot flex">
                <div className="form">
                    <div className="form-title flex align-center justify-center">
                        <h1 className="uppercase">Forgot Password</h1>
                    </div>

                    <Form onSubmit={ this.submitted }>
                        { formApi => (
                            <form onSubmit={formApi.submitForm} id="form5">
                                <div className="inner">
                                    <TextFields type="text" label="Email" field="email"/>
                                </div>
                                <div className="text-center mt-60 mb-50">
                                    <button type="submit" className="btn filled primary min-220">Submit</button>
                                </div>
                            </form>
                        )}
                    </Form>

                </div>
            </div>
        );
    }
}

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/components/Forgot-password/Forgot-password.js